import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { withNamespaces } from 'react-i18next';
import get from 'lodash/get';
import {
  changeBaseModuleScreen,
  changeBaseModuleLang,
  updateBaseModule,
  saveBaseModule,
} from '../../actions/baseModule';
import BaseModuleEditForm from './BaseModuleEditForm';
import BaseModuleLangSelect from './BaseModuleLangSelect';
import { getDefaultLang, getCurrentModuleFormInputs } from '../../selectors';
import i18n from '../../internationalization/i18n';

const propTypes = {
  defaultLang: PropTypes.object.isRequired,
  lang: PropTypes.string.isRequired,
  langs: PropTypes.array.isRequired,
  changeBaseModuleScreen: PropTypes.func.isRequired,
  changeBaseModuleLang: PropTypes.func.isRequired,
  updateBaseModule: PropTypes.func.isRequired,
  saveBaseModule: PropTypes.func.isRequired,
  fieldTypes: PropTypes.array.isRequired,
  initialValues: PropTypes.object,
};

const defaultProps = {
  initialValues: null,
};

class BaseModuleUpdate extends Component {
  constructor(props) {
    super(props);

    this.changeLang = this.changeLang.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  changeLang = (lang) => {
    this.props.changeBaseModuleLang(lang);
  };

  handleSubmit(value) {
    const traverse = (categories, lang) => categories.map((category) => {
      let children = [];
      if (category.children && category.children.categories && category.children.categories.length) {
        children = traverse(category.children.categories, lang);
      }

      return {
        id: get(category, `id.${lang}`),
        title: category.title[lang],
        image: get(category, 'image.id', null),
        image_meta: {
          alt: get(category, 'image.alt', null),
          tooltip: get(category, 'image.tooltip', null),
          hyperlink: get(category, 'image.hyperlink', null),
        },
        children,
      };
    });

    const getLangEntity = function getLangEntity(formData, lang) {
      return {
        id: formData.id[lang],
        label: formData[`label_${lang}`],
        internalName: formData.internalName,
        language: lang,
        fields: formData.fields && formData.fields.map(field => (
          {
            id: get(field, `id.${lang}`),
            label: field.label[lang],
            internalName: field.internalName,
            type: field.type,
          }
        )),
        categories: formData.categories && traverse(formData.categories, lang),
      };
    };

    const entities = this.props.langs.map(lng => getLangEntity(value, lng.code));

    entities.forEach((entity) => {
      // check if entity needs update or create if ID is not defined yet
      const action = entity.id ? this.props.updateBaseModule : this.props.saveBaseModule;
      action(entity);
    });

    this.props.changeBaseModuleScreen('overview');
  }

  render() {
    return (
      <div className="c-bb-basemodule">
        <div className="c-bb-basemodule-header">
          <div className="c-bb-basemodule-header__back-nav" onClick={() => this.props.changeBaseModuleScreen('overview')} >
            <i className="icon-arrows_left" /> {i18n.t('CONTENT.baseModule').toUpperCase()}
          </div>
          <div className="c-bb-basemodule-header-icon-square">
            <i className="icon-edit" />
          </div>
          <BaseModuleLangSelect
            currentLang={this.props.lang}
            onSelect={this.changeLang}
            langs={this.props.langs}
          />
        </div>
        <div className="c-bb-form c-bb-form--has-header">
          <BaseModuleEditForm
            onSubmit={this.handleSubmit}
            initialValues={this.props.initialValues}
            lang={this.props.lang}
            langs={this.props.langs}
            defaultLang={this.props.defaultLang}
            fieldTypes={this.props.fieldTypes}
          />
        </div>
      </div>
    );
  }
}

BaseModuleUpdate.propTypes = propTypes;
BaseModuleUpdate.defaultProps = defaultProps;

const mapStateToProps = state => ({
  isOpen: state.baseModule.isOpen,
  lang: state.baseModule.lang,
  defaultLang: getDefaultLang(state),
  langs: state.baseModule.langs,
  fieldTypes: state.baseModule.fieldTypes,
  initialValues: getCurrentModuleFormInputs(state),
});

const mapDispatchToProps = {
  changeBaseModuleScreen,
  changeBaseModuleLang,
  updateBaseModule,
  saveBaseModule,
};

export default withNamespaces()(connect(mapStateToProps, mapDispatchToProps)(BaseModuleUpdate));



// WEBPACK FOOTER //
// ./src/components/BaseModule/BaseModuleUpdate.js